import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'grid-styled';
/* Components */
import LazyImage from './../../LazyImage/LazyImage';
/* Styles */
import './ProductListImage.scss';

const ProductListImage = ({
  name,
  onProductClick,
  urlShopProduct,
  productCatalog,
  freeUpsGroundShipping,
}) => {
  const imgSrc = `${urlShopProduct}${productCatalog}`;
  return (
    <div className="ProductListImage">
      {freeUpsGroundShipping ? (
        <Flex justify="center" className="purple-circle">
          <Flex column justify="center" className="free-shipping-text">
            <Box className="ships-free">
              1 CENT
              <br />
              SHIP!
            </Box>
          </Flex>
        </Flex>
      ) : null}
      <LazyImage
        imgHeight={532}
        imgWidth={532}
        imgSrc={imgSrc}
        imgAlt={name}
        backgroundColor="#FFFFF"
        onClick={onProductClick}
      />
    </div>
  );
};

ProductListImage.propTypes = {
  productCatalog: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  urlShopProduct: PropTypes.string.isRequired,
  onProductClick: PropTypes.func.isRequired,
  freeUpsGroundShipping: PropTypes.bool,
};

export default ProductListImage;
